export const PasswordStrengthBounds = {
    Weak: {
        minValue: 0,
        maxValue: 18
    },
    Moderate: {
        minValue: 18,
        maxValue: 25
    },
    Strong: {
        minValue: 25,
        maxValue: 30
    },
    VeryStrong: {
        minValue: 30,
        /** Although there isn't really a maximum value for password strength we are considering 10000 just so we
         /*  can have an upper bound to obtain the correct strength.
         **/
        maxValue: 10000
    },
};
